<template>
    <div class="wrapper tab-document">
        <header>
            <span class="new-headline-md text-centered">Letzter Schritt:<br>Nachweis Ihrer Typ-2-Diabetes-Diagnose</span>

            <p class="new-text-md text-centered text-color-default">Für die Kostenübernahme benötigt Ihre Krankenkasse ein Rezept für Vitadio oder ein Dokument mit Ihrem Namen, das Ihre Typ-2-Diabetes-Diagnose bestätigt. Wahrscheinlich haben Sie ein solches Dokument bereits zu Hause. Zum Beispiel:</p>
        </header>

        <ul class="document-list no-list-style">
            <li v-for="document in documents" :key="document" class="new-text-lg">
                <figure>
                    <span class="material-symbols-rounded full-circle icon-check-list text-green">
                        <span>check</span>
                    </span>
                </figure>
                <span>{{ document }}</span>
            </li>
        </ul>

        <strong class="new-text-xl text-centered document-question">Haben Sie eines dieser Dokumente?</strong>

        <div class="form-input-radio-button-wrapper-two-columns">
            <div class="form-input-radio-button-big" @click="$emit('answer', true)">
                <div class="form-input-radio-button-inner">
                    <figure class="form-input-radio-button-icon">
                        <span class="material-symbols-rounded">done</span>
                    </figure>
                    <span class="label-static">Ja</span>
                </div>
            </div>

            <div class="form-input-radio-button-big form-input-radio-button--danger" @click="$emit('answer', false)">
                <div class="form-input-radio-button-inner">
                    <figure class="form-input-radio-button-icon">
                        <span class="material-symbols-rounded">close</span>
                    </figure>
                    <span class="label-static">Nein</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            documents: [
                'Rezept für Vitadio', 'Diabetespass', 'Arztbrief',
                'Medikamentenplan', 'Befundbericht', 'Überweisungsschein'
            ]
        }
    }
}
</script>
